module.exports = __webpack_public_path__ + "static/pmep_logo-f6fd78ea9f14fc121f2d243de5362df2.png";